import type { ComputedRef } from 'vue'

export default function useSeoHeadTags(
  {
    title,
    titleTemplate,
    description,
    image,
  }: {
    title: ComputedRef<string>
    titleTemplate?: Nullable<ComputedRef<string>>
    description: ComputedRef<string>
    image?: ComputedRef<string | undefined>
  },
) {
  const route = useRoute()
  const absoluteLocalePath = useAbsoluteLocalePath()
  const { getStaticImage } = useImage()

  const pageUrl = computed(() => absoluteLocalePath(route.fullPath))

  const shareImage = computed(() => getStaticImage({
    path: '/web-app/share-img-20260601.jpg',
  }))

  useSeoMeta({
    title,
    titleTemplate,
    description,

    ogType: 'website',
    ogTitle: title,
    ogDescription: description,
    ogUrl: pageUrl,
    ogImage: image ?? shareImage.value,

    twitterCard: 'summary_large_image',
    twitterTitle: title,
    twitterDescription: description,
    twitterSite: pageUrl,
    twitterImage: image ?? shareImage.value,
  })
}
